import { useDashboardData } from '@/hooks/useDashboardData'
import { StatCard, ProgressBar } from '@/components/shared/StatCard'
import { DecadeChart } from '@/components/features/dashboard/DecadeChart'
import { EntityStats } from '@/components/features/dashboard/EntityStats'

export function Dashboard() {
  const { dashboard, isLoading, error } = useDashboardData()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-muted-foreground">Loading dashboard data...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="rounded-lg border border-destructive/50 bg-destructive/10 p-6">
        <h2 className="font-semibold text-destructive">Failed to load dashboard</h2>
        <p className="mt-1 text-sm text-muted-foreground">{error.message}</p>
      </div>
    )
  }

  if (!dashboard) return null

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Dashboard</h1>
        <p className="mt-1 text-muted-foreground">
          Concert archive statistics and quality overview.
        </p>
      </div>

      {/* Concerts section */}
      <section className="space-y-4">
        <h2 className="text-lg font-semibold">Concerts</h2>
        <div className="grid gap-4 sm:grid-cols-3">
          <StatCard title="Total Concerts" subtitle="1910–2024">
            <div className="text-2xl font-bold tracking-tight">{dashboard.totalConcerts}</div>
          </StatCard>
          <StatCard title="Programme Items">
            <div className="text-2xl font-bold tracking-tight">{dashboard.totalProgrammeItems}</div>
          </StatCard>
          <StatCard title="Fully Matched">
            <ProgressBar matched={dashboard.fullyMatchedConcerts} total={dashboard.totalConcerts} />
          </StatCard>
        </div>

        <div className="rounded-lg border bg-card p-6">
          <h3 className="mb-4 text-sm font-medium text-muted-foreground">Concerts by Decade</h3>
          <DecadeChart decades={dashboard.decades} />
        </div>
      </section>

      {/* Entity stats columns */}
      <section className="grid gap-8 lg:grid-cols-3">
        <EntityStats title="Composers" stats={dashboard.composers} />
        <EntityStats title="Works" stats={dashboard.works} />
        <EntityStats title="Performers" stats={dashboard.performers} />
      </section>
    </div>
  )
}
